import { render, staticRenderFns } from "./TotalList.vue?vue&type=template&id=6eb5e0f0&scoped=true&"
import script from "./TotalList.vue?vue&type=script&lang=js&"
export * from "./TotalList.vue?vue&type=script&lang=js&"
import style0 from "./TotalList.vue?vue&type=style&index=0&id=6eb5e0f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb5e0f0",
  null
  
)

export default component.exports